import angular from 'angular'

// components
import signIn from './component/signIn.component.js'

export default angular
  .module('auth.signIn', [])
  .component('signIn', signIn)
  .name
